import { DefaultCell } from "../../../../Component/Common/Components/DataTable/DefaultCell";
import { ActionType, TableColumn } from "../../../../Component/Model/Table/Table";
import { ActionsCell } from "../../../../Component/Common/Components/DataTable/ActionsCell";
import { CertificateRegistry } from "../../../../Component/Model/Dto/CertificateRegistry/CertificateRegistry";
import { DateFormatter } from "../../../../Component/Model/helpers";

interface CertificatesRow {
    certificateType: string;
    certificateNumber: string;
    version: string;
    bbbeeLevel: string;
    issueDate: string;
    expiryDate: string;
    actions: ActionType[];
}

interface CertificatesTable {
    columns: Array<TableColumn>;
    rows: Array<CertificatesRow>;
}

function getActionColumns(item: CertificateRegistry.CertificateRegistrySearchResult, downloadCertificate: (documentId: number) => void): ActionType[] {
    const actions: ActionType[] = [];
    if (item.portalDocumentId) {
        actions.push(
            // Future icon for viewing without downloading
            // {
            //     key: item.toString(),
            //     label: 'View Certificate',
            //     action: () => { },
            //     icon: {
            //         color: 'secondary',
            //         name: 'visibility'
            //     }
            // },
            {
                key: item.toString(),
                label: 'Download Certificate',
                action: () => {
                    downloadCertificate(item.portalDocumentId!);
                },
                icon: {
                    color: 'secondary',
                    name: 'file_download'
                }
            }
        )
    }
    return actions;
}

export function CertificatesTableMapper(results: CertificateRegistry.CertificateRegistrySearchResult[], downloadCertificate: (documentId: number) => void): CertificatesTable {
    const columns = [
        { Header: 'Certificate Type', accessor: 'certificateType', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Certificate Number', accessor: 'certificateNumber', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Version', accessor: 'version', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'B-BBEE Level', accessor: 'bbbeeLevel', id: "startDate", Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Issue Date', accessor: 'issueDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Expiry Date', accessor: 'expiryDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true, }
    ];

    if (results.length >= 0) {
        const rows: CertificatesRow[] = results.map((item: CertificateRegistry.CertificateRegistrySearchResult) => (
            {
                certificateType: item.certificateType ?? '',
                certificateNumber: item.certificateNumber,
                version: item.versionNumber ?? '',
                bbbeeLevel: item.complianceLevel,
                issueDate: DateFormatter(item.issueDate.toString()),
                expiryDate: DateFormatter(item.expiryDate.toString()),
                actions: getActionColumns(item, downloadCertificate)
            }));
        return { columns: columns, rows: rows };
    } else {
        return { columns: columns, rows: [] };
    }
}